import { baseConfig } from "config";
import { BaseDocumentFolder, DocumentFolderType } from "services/types";
import * as Yup from "yup";

const ValidationHelper = {
	validateMinimumFolderDocumentCount(
		documentFolder: BaseDocumentFolder,
		folderTypeData: DocumentFolderType | undefined,
		forceRequired = false
	): boolean {
		const { documents } = documentFolder;
		const isTestExecutable = folderTypeData && documents;
		if (!isTestExecutable) return true;

		const folderHasNoDocument = documents.length === 0;
		const isDocumentsOptional =
			!folderTypeData.alwaysRequired && folderHasNoDocument && !forceRequired;
		const isDocumentsMoreThanMinimum =
			documents.length >= folderTypeData.minAmountDocuments;
		return Boolean(isDocumentsOptional || isDocumentsMoreThanMinimum);
	},
	validateMaximumFolderDocumentCount(
		documentFolder: BaseDocumentFolder,
		folderTypeData: DocumentFolderType | undefined
	): boolean {
		const { documents } = documentFolder;
		const isTestExecutable = folderTypeData && documents;
		if (!isTestExecutable) return true;
		if (
			folderTypeData.maxAmountDocuments === null ||
			folderTypeData.maxAmountDocuments === undefined
		)
			return true;

		return documents.length <= folderTypeData.maxAmountDocuments;
	},
	validateMaximumTotalDocumentCount(value: Record<string, BaseDocumentFolder>) {
		const totalDocuments = Object.values(value).reduce(
			(acc, folder) => acc + folder.documents.length,
			0
		);
		return totalDocuments <= baseConfig.maxSubmissionApplicationFiles;
	},
	documentMinimumCountMessage:
		"Adicione a quantidade mínima de arquivos para a pasta",
	documentMaximumCountMessage:
		"Não ultrapasse a quantidade máxima de arquivos para a pasta",

	buildDocumentFoldersSchema(
		folderKeys: string[],
		folderTypeById: Record<string, DocumentFolderType>,
		baseFolderSchema: Yup.AnyObjectSchema,
		forceAllRequired = false
	): Yup.AnyObjectSchema {
		return Yup.object()
			.shape(
				Object.fromEntries(
					folderKeys.map((folderKey) => [
						folderKey,
						baseFolderSchema
							.test(
								"minDocumentsTest",
								ValidationHelper.documentMinimumCountMessage,
								(value: BaseDocumentFolder) => {
									return ValidationHelper.validateMinimumFolderDocumentCount(
										value,
										folderTypeById[value.interventionDocumentFolderType],
										forceAllRequired
									);
								}
							)
							.test(
								"maxDocumentsTest",
								ValidationHelper.documentMaximumCountMessage,
								(value: BaseDocumentFolder) => {
									return ValidationHelper.validateMaximumFolderDocumentCount(
										value,
										folderTypeById[value.interventionDocumentFolderType]
									);
								}
							)
					])
				)
			)
			.test(
				"maxSubmissionApplicationFiles",
				`É possível anexar no máximo ${baseConfig.maxSubmissionApplicationFiles} arquivos`,
				(val) => ValidationHelper.validateMaximumTotalDocumentCount(val)
			);
	}
};
export default ValidationHelper;
